/*
 * @Author: hai.yang3 hai.yang3@gientech.com
 * @Date: 2022-08-18 17:53:06
 * @LastEditors: wangkg wangkegui@longfor.com
 * @LastEditTime: 2022-12-23 07:46:51
 * @FilePath: \unified-development-platform\src\store\modules\move-auth\sysUserManagement.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {get_users, get_all_enable_users, get_user_info} from '@/apis/auth/move-auth/platform/user_manage_api.js';

const types = {
  GET_USERS: 'GET_USERS',
  GET_ALL_USERS: 'GET_ALL_USERS',
  GET_ENABLE_USERS: 'GET_ENABLE_USERS',
  GET_USER_INFO: 'GET_USER_INFO'
};
const state = {
  users: {},
  allUsers: [],
  enableUsers: [],
  userInfo: {}
};
const actions = {
  async getListWithSearch(context, params) {
    let res = await get_users(params);
    if (res) {
      context.commit(types.GET_USERS, res);
    }
    return res;
  },
  async getAllUsers(context, params) {
    let res = await get_users(params);
    if (res) {
      context.commit(types.GET_ALL_USERS, res.list);
    }
    return res.list;
  },
  async getEnableUsers(context, params) {
    let res = await get_all_enable_users(params);
    if (res) {
      context.commit(types.GET_ENABLE_USERS, res.list);
    }
    return res.list;
  },
  async getUserInfo(context) {
    let res = await get_user_info();
    if (res) {
      context.commit(types.GET_USER_INFO, res);
    }
    return res;
  }
};
const mutations = {
  [types.GET_USERS](state, payload) {
    state.users = payload;
  },
  [types.GET_ALL_USERS](state, payload) {
    state.allUsers = payload;
  },
  [types.GET_ENABLE_USERS](state, payload) {
    state.enableUsers = payload;
  },
  [types.GET_USER_INFO](state, payload) {
    state.userInfo = payload;
  }
};
const getters = {
  users: (state) => state.users,
  allUsers: (state) => state.allUsers,
  enableUsers: (state) => state.enableUsers,
  userInfo: (state) => state.userInfo
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
